import { useState } from "react";

import { HStack, Button, Box } from "@libs/design";

export type TabsProps = {
  activeTab: string;
  onTabChange: (tab: string) => void;
};

export const Tabs = ({ activeTab, onTabChange }: TabsProps) => {
  const tabs = ["overview", "countries", "alerts", "tickets", "company"];
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  const colors = {
    activeBg: "#00927B",
    activeText: "#FFFFFF",
    inactiveText: "#6B7280",
    hoverBg: "#D1FAE5",
    hoverText: "#00927B",
  };

  return (
    <Box
      mt={4}
      overflowX={{ base: "auto", md: "visible" }}
      whiteSpace="nowrap"
      css={{
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <HStack gap={2} minW="max-content">
        {tabs.map((tab) => {
          const isActive = activeTab === tab;
          const isHovered = hoveredTab === tab;

          const getBackgroundColor = () => {
            if (isActive) return colors.activeBg;
            if (isHovered) return colors.hoverBg;
            return "transparent";
          };

          const getTextColor = () => {
            if (isActive) return colors.activeText;
            if (isHovered) return colors.hoverText;
            return colors.inactiveText;
          };

          return (
            <Button
              key={tab}
              onClick={() => onTabChange(tab)}
              onMouseEnter={() => setHoveredTab(tab)}
              onMouseLeave={() => setHoveredTab(null)}
              px={{ base: 4, md: 5 }}
              py={{ base: 2, md: 2.5 }}
              fontSize={{ base: "xs", md: "sm" }}
              fontWeight="medium"
              borderRadius="full"
              borderWidth="0"
              flexShrink={0}
              style={{
                backgroundColor: getBackgroundColor(),
                color: getTextColor(),
                transition: "all 0.2s ease",
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </Button>
          );
        })}
      </HStack>
    </Box>
  );
};
